var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 28",
    style: {
      enableBackground: "new 0 0 36 28"
    },
    xmlSpace: "preserve",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EA4335;}\n\t.st1{fill:#4285F4;}\n\t.st2{fill:#34A853;}\n\t.st3{fill:#FBBC05;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.41,8.07h1l2.85-2.85l0.14-1.21C21.1-0.67,13-0.16,8.32,5.14c-1.3,1.47-2.24,3.23-2.76,5.12 c0.32-0.13,0.67-0.15,1-0.06l5.7-0.94c0,0,0.29-0.48,0.44-0.45c2.54-2.78,6.8-3.11,9.73-0.74L22.41,8.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.32,10.26c-0.66-2.41-2-4.58-3.87-6.24l-4,4c1.69,1.38,2.65,3.46,2.61,5.64v0.71 c1.97,0,3.56,1.59,3.56,3.56s-1.59,3.56-3.56,3.56h-7.12l-0.71,0.72v4.27l0.71,0.71h7.12c5.11,0.04,9.29-4.07,9.33-9.19 C34.42,14.91,32.89,12,30.32,10.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.81,27.15h7.12v-5.7h-7.12c-0.51,0-1.01-0.11-1.47-0.32l-1,0.31l-2.87,2.85l-0.25,1 C6.83,26.51,8.79,27.16,10.81,27.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.81,8.66c-5.11,0.03-9.24,4.2-9.2,9.32c0.02,2.86,1.35,5.54,3.61,7.28l4.13-4.13 c-1.79-0.81-2.59-2.92-1.78-4.71s2.92-2.59,4.71-1.78c0.79,0.36,1.42,0.99,1.78,1.78l4.13-4.13C16.43,10,13.7,8.65,10.81,8.66z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpLogo);
export default __webpack_public_path__ + "static/media/gcp-logo.1275be1deb6d802bc5c6fb58677f7aa9.svg";
export { ForwardRef as ReactComponent };